import { useCallback } from 'react';

import { useAtomValue } from 'jotai';
import { useLocalStorage } from 'usehooks-ts';

import {
  emptyAddress,
  RegistrationDataT,
  STATE_LOCAL_STORAGE_KEY,
  StateValueT,
} from '@consumer-frontend/nc-utils';
import { Container } from '@consumer-frontend/shared-ui';

import { useApplyRouting } from '../../routing';
import { registrationDataAtom } from '../../store';
import { NcProgressBar } from '../NcProgressBar';
import { NcVerifyContactInfoForm } from '../NcVerifyContactInfoForm/NcVerifyContactInfoForm';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/apply/verify-contact-info-page.scss';

export const NcVerifyContactInfoPage: React.FC = () => {
  const registrationData = useAtomValue(registrationDataAtom);
  const [_, setAddressState] = useLocalStorage<StateValueT | ''>(STATE_LOCAL_STORAGE_KEY, '');
  const { handleContinue, progress } = useApplyRouting();

  const handleSubmit = useCallback(
    async ({ address, phoneNumber }: Partial<RegistrationDataT>): Promise<void> => {
      setAddressState(address?.state ?? '');

      await handleContinue({ address, phoneNumber });
    },
    [handleContinue, setAddressState],
  );

  return (
    <Container className="nc-verify-contact-info-page" hasBoxShadow>
      <NcProgressBar progress={progress} />

      <h1 className="h3">Verify Phone and Address</h1>

      <NcVerifyContactInfoForm
        defaultAddress={registrationData.address ?? emptyAddress}
        defaultPhoneNumber={registrationData.phoneNumber ?? ''}
        onSubmit={handleSubmit}
      />
    </Container>
  );
};
